@if (section(); as s) {
  <section [id]="s.id" class="contact-section">
    <div class="contact-container">
      <div class="contact-header">
        <h2 class="contact-title">{{ s.title }}</h2>
        <p class="contact-subtitle">{{ s.subtitle }}</p>
      </div>

      <form class="contact-form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="contact-honeypot" aria-hidden="true">
          <label for="contact-website">Weboldal</label>
          <input id="contact-website" type="text" formControlName="website" tabindex="-1" autocomplete="off">
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Név *</mat-label>
            <input matInput formControlName="name" placeholder="Kovács János">
            @if (form.controls.name.invalid && form.controls.name.touched) {
              <mat-error>A név megadása kötelező.</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Cégnév</mat-label>
            <input matInput formControlName="companyName" placeholder="Példa Kft.">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>E-mail cím *</mat-label>
            <input matInput formControlName="email" type="email" placeholder="pelda@ceg.hu">
            @if (form.controls.email.invalid && form.controls.email.touched) {
              <mat-error>Érvényes e-mail cím megadása kötelező.</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Telefonszám</mat-label>
            <input matInput formControlName="phone" placeholder="+36 30 123 4567">
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Milyen típusú weboldalra van szükséged? *</mat-label>
          <mat-select formControlName="siteType">
            @for (option of siteTypeOptions(); track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (form.controls.siteType.invalid && form.controls.siteType.touched) {
            <mat-error>Kérjük, válassz egy típust.</mat-error>
          }
        </mat-form-field>

        <div class="form-field-group">
          <label class="form-label">Van már meglévő weboldalad?</label>
          <mat-radio-group formControlName="hasExistingWebsite" class="radio-group">
            <mat-radio-button value="igen">Igen</mat-radio-button>
            <mat-radio-button value="nem">Nem</mat-radio-button>
          </mat-radio-group>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Üzenet (opcionális)</mat-label>
          <textarea
            matInput
            formControlName="message"
            rows="4"
            placeholder="Bármilyen egyéb gondolat, kérdés..."
          ></textarea>
        </mat-form-field>

        <div class="form-field-group">
          <mat-checkbox formControlName="privacyConsent">
            Elfogadom az
            <a href="/adatvedelmi-nyilatkozat" target="_blank" rel="noopener">adatvédelmi nyilatkozatot</a>,
            és hozzájárulok, hogy az ALL-IN-DEV a megadott adatokat az ajánlatkérés feldolgozásához kezelje. *
          </mat-checkbox>
          @if (form.controls.privacyConsent.invalid && form.controls.privacyConsent.touched) {
            <p class="consent-error">Az adatkezelési hozzájárulás kötelező.</p>
          }
        </div>

        <div class="form-submit">
          <button
            mat-raised-button
            class="btn-primary"
            type="submit"
            [disabled]="status() === 'loading'"
          >
            @if (status() === 'loading') {
              Küldés folyamatban...
            } @else {
              Kérek ajánlati konzultációt
            }
          </button>
        </div>
      </form>
    </div>
  </section>
}
